export default __webpack_public_path__ + "static/media/stonk-bot-site-img.8df5ae01.png";